// shared/src/schemas/check-log.ts
// Zod schema for `check_log` table (D1 migration 0001_init.sql:142-154).
// 10 columns; A2 drift-detector enforces field-name parity.

import { z } from 'zod';

export const CheckLogSeverityEnum = z.enum(['PASS', 'WARN', 'FAIL', 'SKIP']);
export const CheckLogTypeEnum = z.enum([
  'dv',
  'painter_validate',
  'dash_invariant',
  'unit_test',
  'log_validate',
  'render_guard',
  'pipeline_validator',
]);

export const CheckLogSchema = z.object({
  id:         z.string(),
  brief_id:   z.string().nullable(),
  run_id:     z.string().nullable(),
  created_at: z.string().datetime(),
  severity:   CheckLogSeverityEnum,
  check_type: CheckLogTypeEnum,
  stage:      z.string(),
  check_name: z.string(),
  message:    z.string(),
  details:    z.string().nullable(),    // JSON or NULL
});

export type CheckLog = z.infer<typeof CheckLogSchema>;
